import React from "react";
import DonutChartWidget from "./DonutChartWidget";

const COLORS = ['#23407A', '#00FEC1'];
const DARK_COLORS = ['#1681F6', '#00FEC1'];

export interface CallStatusDonutWidgetData {
  answeredCall: number;
  missedCall: number;
}

interface CallStatusDonutWidgetProps {
  data: CallStatusDonutWidgetData;
  loading?: boolean;
  error?: string;
  onClick?: (filters: { [key: string]: string[] }) => void;
  title: string;
  tooltipDescription: string;
  directionFilterLabel: string;
  legendVerticalAlign: 'bottom' | 'middle';
}

// Shared by OutboundCallStatusWidget and InboundDirectCallsDistributionWidget — the
// two widgets are otherwise identical Answered/Missed donut charts that only differ
// in title, tooltip copy, the filter's direction label, and legend vertical alignment.
const CallStatusDonutWidget: React.FC<CallStatusDonutWidgetProps> = ({
  data,
  loading,
  error,
  onClick,
  title,
  tooltipDescription,
  directionFilterLabel,
  legendVerticalAlign,
}) => {
  const donutData = [
    { name: 'Answered', value: data.answeredCall || 0 },
    { name: 'Missed', value: data.missedCall || 0 },
  ];

  const handleSegmentClick = (segmentName: string, value: number) => {
    if (onClick && value > 0) {
      onClick({ callStatus: [segmentName], direction: [directionFilterLabel] });
    }
  };

  return (
    <DonutChartWidget
      title={title}
      tooltipDescription={tooltipDescription}
      data={donutData}
      colors={COLORS}
      darkColors={DARK_COLORS}
      loading={loading}
      error={error}
      onSegmentClick={onClick ? handleSegmentClick : undefined}
      legendVerticalAlign={legendVerticalAlign}
    />
  );
};

export default CallStatusDonutWidget;
